import { TableComponent as Table } from '../../components'
import { Tag } from 'antd'
import moment from 'moment'

const statusColor = {
    success: 'green',
    error: 'red',
    skipped: 'orange'
}

const statusLabel = {
    success: 'Sucesso',
    error: 'Erro',
    skipped: 'Ignorado'
}

const AutomacaoLogsTable = ({ logs, loading }) => {
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: 70
        },
        {
            title: 'Início',
            dataIndex: 'started_at',
            key: 'started_at',
            align: 'center',
            width: 160,
            render: (value) => value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-'
        },
        {
            title: 'Fim',
            dataIndex: 'finished_at',
            key: 'finished_at',
            align: 'center',
            width: 160,
            render: (value) => value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: 110,
            render: (status) => (
                <Tag color={statusColor[status] || 'default'}>
                    {statusLabel[status] || status}
                </Tag>
            )
        },
        {
            title: 'Origem',
            dataIndex: 'triggered_by',
            key: 'triggered_by',
            align: 'center',
            width: 100,
            render: (value) => value === 'cron' ? 'Cron' : 'Manual'
        },
        {
            title: 'Cotação',
            key: 'cotacao',
            align: 'center',
            width: 140,
            render: (_, record) => {
                if (record.cotacao == null) return '-'
                return `${record.cotacao} (${record.modo_cotacao || '-'})`
            }
        },
        {
            title: 'Valor saída',
            dataIndex: 'valor_saida',
            key: 'valor_saida',
            align: 'center',
            width: 120,
            render: (value) => (value != null ? Number(value) : '-')
        },
        {
            title: 'Op. Geral',
            dataIndex: 'id_operacao_geral',
            key: 'id_operacao_geral',
            align: 'center',
            width: 100,
            render: (value) => value ?? '-'
        },
        {
            title: 'Mensagem',
            dataIndex: 'message',
            key: 'message',
            align: 'left',
            width: 420,
            render: (value, record) => (
                <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {value || record.error_detail || '-'}
                </div>
            )
        }
    ]

    return (
        <div id="automacao-logs-table">
            <Table
                loading={loading}
                column={columns}
                data={logs}
                id="automacao-logs"
                scroll={{ x: 1380 }}
            />
        </div>
    )
}

export default AutomacaoLogsTable
